(function () {
  var GIFT_TOAST_CLOSE = '#salepify-embed-widget__toast-close-button';
  var GIFT_TRADEMARK = '.salepify-popup__trademark';
  var PREVIEW_FRAME = 'iframe#PBarNextFrame';
  var VIDEO_FALLBACK_IMAGE = 'video > img:not([alt])';

  function patchAccessibility(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    var giftClose = root.matches && root.matches(GIFT_TOAST_CLOSE)
      ? root
      : root.querySelector && root.querySelector(GIFT_TOAST_CLOSE);

    if (giftClose && !giftClose.getAttribute('aria-label')) {
      giftClose.setAttribute('aria-label', 'Close gift notification');
    }

    var giftTrademark = root.matches && root.matches(GIFT_TRADEMARK)
      ? root
      : root.querySelector && root.querySelector(GIFT_TRADEMARK);

    if (giftTrademark && giftTrademark.parentElement) {
      var inheritedColor = window.getComputedStyle(giftTrademark.parentElement).color;
      giftTrademark.style.setProperty('color', inheritedColor, 'important');

      var giftTrademarkLink = giftTrademark.querySelector('a');
      if (giftTrademarkLink) giftTrademarkLink.style.setProperty('color', 'inherit', 'important');
    }

    var previewFrame = root.matches && root.matches(PREVIEW_FRAME)
      ? root
      : root.querySelector && root.querySelector(PREVIEW_FRAME);

    if (previewFrame && !previewFrame.getAttribute('title')) {
      previewFrame.setAttribute('title', 'Shopify theme preview controls');
    }

    var videoFallbackImages = [];
    if (root.matches && root.matches(VIDEO_FALLBACK_IMAGE)) videoFallbackImages.push(root);
    if (root.querySelectorAll) {
      videoFallbackImages = videoFallbackImages.concat(Array.from(root.querySelectorAll(VIDEO_FALLBACK_IMAGE)));
    }
    videoFallbackImages.forEach(function (image) {
      image.setAttribute('alt', '');
    });
  }

  patchAccessibility(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(patchAccessibility);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
